<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="w-full flex justify-between mr-4">
				<div>
					<h4 class="uppercase font-bold block text-xl w-full">{{ $t("DetailProduct") }}</h4>
				</div>
				<ProductContextMenu
					:productItem="localData"
					@onClickAddQuote="data => $emit('onClickAddQuote', data)"
					@onClickEdit="data => $emit('onClickEdit', data)"
					@onClickDelete="data => $emit('onClickDelete', data)"
				/>
			</div>
			<div>
				<div class="p-6">
					<vs-row class="mb-2">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("ProductCode") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localData.code }}</vs-col>
					</vs-row>
					<vs-row class="mb-2">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("ProductName") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localData.name }}</vs-col>
					</vs-row>

					<vs-row class="mb-2">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("Price") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localData.price) }}</vs-col>
					</vs-row>

					<!-- Description -->

					<vs-row class="mb-2">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("ExpiredDays") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localData.expired_days) }}</vs-col>
					</vs-row>
					<vs-row class="mb-2">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("Quantity") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localData.quantity) }}</vs-col>
					</vs-row>
					<vs-row class="mb-2">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("QtyLimit") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ $helper.numFormat(localData.qty_limit) }}</vs-col>
					</vs-row>
					<vs-row class="mb-2" v-if="localData.description">
						<vs-col vs-w="4" vs-xs="6">
							<label for>{{ $t("Description") }}:</label>
						</vs-col>
						<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localData.description }}</vs-col>
					</vs-row>
					<!-- Attachments -->
					<vs-row class="mb-2" v-if="localData.front_image">
						<vs-col vs-w="4">
							<label class="text-solid-gray-1">{{ $t("Image") }}:</label>
							<div>
								<img v-if="localData && localData.front_image && localData.front_image.path" :src="localData.front_image.path" alt="" class="w-16" />
							</div>
						</vs-col>
					</vs-row>
				</div>
				<!-- ImportInformation -->
				<el-collapse @change="toggleLogs" id="product-logs-with-loading" class="vs-con-loading__container cbs-collapse">
					<el-collapse-item name="1">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">{{ $t("ImportInformation") }}</h6>
						</template>
						<div class="px-3">
							<vs-table ref="table" class="stack-table" :sst="true" :data="logs" :noDataText="$t('Notify.NoDataAvailable')">
								<template slot="thead">
									<vs-th sort-key="imported_at">
										<h6 class="font-normal">{{ $t("DateAdded") }}</h6>
									</vs-th>
									<vs-th sort-key="lot_number">
										<h6 class="font-normal">{{ $t("LotNumber") }}</h6>
									</vs-th>
									<vs-th sort-key="quantity">
										<h6 class="font-normal">{{ $t("Numbers") }}</h6>
									</vs-th>
									<vs-th sort-key="expired_days">
										<h6 class="font-normal">{{ $t("ExpiredDays") }}</h6>
									</vs-th>
								</template>

								<template slot-scope="{ data }">
									<tbody>
										<vs-tr class="cursor-default" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data-header="$t('DateAdded')">
												<p class="text-base">{{ tr.imported_at | dateTime("DD/MM/YYYY") }}</p>
											</vs-td>
											<vs-td :data-header="$t('LotNumber')">
												<p class="text-base">{{ tr.lot_number }}</p>
											</vs-td>

											<vs-td :data-header="$t('Numbers')">
												<p class="text-base text-base">{{ $helper.numFormat(tr.quantity) }}</p>
											</vs-td>

											<vs-td :data-header="$t('ExpiredDays')">
												<p class="w-full text-base">{{ $helper.numFormat(tr.expired_days) }}</p>
											</vs-td>
										</vs-tr>
									</tbody>
								</template>
							</vs-table>
							<CbsPagination class="mt-3" :total="totalPages" v-model="page" />
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

import LogsTodoByRelations from "@/components/logs-todo-by-relations/LogsTodoByRelations";
import ProductContextMenu from "./ProductContextMenu.vue";
import customerGql from "@/http/requests/card/customer_gql";

export default {
	name: "ProductDetailDialog",
	components: { CbsUploadRef, LogsTodoByRelations, ProductContextMenu },

	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		product: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showLogsCurrentTodo: true,
			showLogsDoneTodo: true,
			logs: [],
			page: 1,
			limit: 10,
			total: 0
		};
	},
	watch: {
		page() {
			this.getLogs();
		}
	},

	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar", val);
				}
			}
		},

		localData() {
			const product = this.product;
			return product ? product : {};
		},
		totalPages() {
			return Math.ceil(this.total / this.limit);
		}
	},
	methods: {
		toggleLogs(ev) {
			if (ev.length > 0 && this.logs.length === 0) {
				this.getLogs(this.product.id);
			}
		},
		async getLogs(id) {
			this.$vs.loading({
				container: "#product-logs-with-loading",
				scale: 0.6
			});
			try {
				const { product_stocks, total } = await customerGql.getListProductStocks({ page: this.page, limit: this.limit, product_id: id });
				if (product_stocks && product_stocks) {
					this.logs = product_stocks;
					this.total = total;
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.$vs.loading.close("#product-logs-with-loading > .con-vs-loading");
			}
		}
	}
};
</script>

<style></style>
